import { getActiveService } from "../../../../utilities/activeService";
import { querySelectorURL } from "../../../cpcoc/querySelectorURL";
import { createSlide } from "../../slidesOps/createSlide";
import "./index.scss";
export function slideWorshipPointer() {
    const activeService = getActiveService();
    const group = querySelectorURL("group");
    const delay = 500;
    const livestream = group === "livestream";
    const html = `
        <div class="pointer worship-pointer">
            <div class="title-group">
                <h2 class="text-color fragment fade-left" data-autoslide="${delay}">
                    <img class="title-image" src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/worship.svg" alt="Worship" />
                </h2>
                <p class="start-time fragment fade-left" data-autoslide="${delay}">
                    @ ${activeService.time} ${activeService.period}${livestream ? " " + activeService.timezone : ""}
                </p>
                <p class="start-time_arrow fragment fade-left" data-autoslide="${delay * 4}">
                    <img src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/arrow-left.svg" alt="Turn left" />
                </p>
            </div>
            <div class="bottom-right-group">
                <p class="restroom text-color fragment fade-right" data-autoslide="${delay}">
                    <img src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/restrooms.svg" alt="Restrooms" />
                </p>
                <p class="restroom-arrow start-time fragment fade-right" data-autoslide="${delay}">
                    <img src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/arrow-right.svg" alt="Turn right" />
                </p>
            </div>
        </div>
        <div class="fragment" data-autoslide="15000"></div>
    `;
    createSlide({
        autoslide: 150,
        center: true,
        html: html,
        background: { color: null },
    }, "worshippointer");
}
